import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "modalRef",
  class: "modal-content neon"
}
const _hoisted_2 = { ref: "canvas" }
const _hoisted_3 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_modal_header = _resolveComponent("app-modal-header")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_file_uploader = _resolveComponent("app-file-uploader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_modal_header, { onClose: _ctx.close }, null, 8, ["onClose"]),
    _createElementVNode("div", {
      ref: "wrap",
      class: "canvas-wrap",
      onPointerdown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startPan && _ctx.startPan(...args))),
      onWheel: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onWheel && _ctx.onWheel(...args)), ["prevent"])),
      onPointermove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onPointerMove && _ctx.onPointerMove(...args))),
      onPointerup: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.endPan && _ctx.endPan(...args))),
      onPointercancel: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.endPan && _ctx.endPan(...args))),
      onPointerleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.endPan && _ctx.endPan(...args)))
    }, [
      _createElementVNode("canvas", _hoisted_2, null, 512)
    ], 544),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_app_button, {
        severity: "secondary",
        raised: "",
        icon: ['fas', 'undo'],
        onClick: _ctx.reset
      }, null, 8, ["onClick"]),
      _createVNode(_component_app_button, {
        severity: "secondary",
        raised: "",
        icon: ['fas', 'plus'],
        onClick: _ctx.zoomIn
      }, null, 8, ["onClick"]),
      _createVNode(_component_app_button, {
        severity: "secondary",
        raised: "",
        icon: ['fas', 'minus'],
        onClick: _ctx.zoomOut
      }, null, 8, ["onClick"]),
      _createVNode(_component_app_button, {
        severity: "secondary",
        raised: "",
        icon: ['fas', 'share'],
        onClick: _ctx.exportImage
      }, null, 8, ["onClick"]),
      _createVNode(_component_app_file_uploader, {
        "is-show-sign": false,
        "is-title": false,
        onSelect: _ctx.onFileSelected
      }, null, 8, ["onSelect"])
    ])
  ], 512))
}